export enum EnvLevel {
  DEV = 'dev',
  PREPROD = 'preprod',
  PROD = 'prod',
}

export const getEnvLevel = () =>
  process.env.GATSBY_ENV_LEVEL as EnvLevel | undefined;
